import { isLocalhost } from '@/features/common/helpers';

export function addClarityCustomTags(userInfo) {
  if (!userInfo || !window.clarity) {
    return;
  }

  if (userInfo.username) {
    window.clarity('set', 'username', userInfo.username);
  }

  if (userInfo.account) {
    window.clarity('set', 'account', userInfo.account);
  }
}

export function addClarityScript() {
  if (isLocalhost()) return;

  const script = document.createElement('script');
  script.type = 'text/javascript';
  script.text = `
    (function(c,l,a,r,i,t,y){
      c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
      t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
      y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
    })(window, document, "clarity", "script", "${process.env.VUE_APP_CLARITY_TRACKING_CODE}");
  `;
  script.async = true;
  script.defer = true;
  document.head.appendChild(script);
}
